
import { RemoveMessage } from '@/core/helper/validation-rule-helper';
import { t } from 'i18next';
import { useCallback, useEffect, useRef, useState } from 'react'
// import DataGridWrapper from '@/core/wrappers/data-grid-wrapper';
import DataGridWrapper from '@/projects/syncflow/components/data-grid-wrapper';
import CustomStore from 'devextreme/data/custom_store';
import React from 'react';
import { Button } from 'devextreme-react/button';
import { DataGrid, Popup } from 'devextreme-react';
import { orderService } from '../services/order-service';
import { useNavigate, useParams } from 'react-router-dom';
import { IOrderDetail } from '@/core/interfaces/usestate-interfaces';
import moment from 'moment';
import OrderStatusCell from './components/order-status-celll';

function OrderDetail() {

    const dataGridRef = useRef<DataGrid>(null);
    const [store, setStore] = useState<CustomStore>();

    useEffect(() => {
        setStore(new CustomStore({
            key: ["id"],
            load: onGetOrderData,
            useDefaultSearch: true
        }));
    }, [])


    const params = useParams();
    let strOrNumber: string | number = "";
    const onGetOrderData = useCallback(async () => {
        strOrNumber = params.id != undefined ? params.id : "";
        const x = await orderService.getOrderDetailList(parseInt(strOrNumber));
        return x;
    }, []);


    const [account, setAccount] = useState<IOrderDetail>();
    useEffect(() => {
        if (account == null) {
            const fetchAccounts = async () => {
                strOrNumber = params.id != undefined ? params.id : "";
                const data = await orderService.getOrderDetail(parseInt(strOrNumber));
                setAccount(data)
            };
            fetchAccounts();
        }
    }, [account])

    const onFocusedCellChanging = (e: { isHighlighted: boolean; }) => {
        e.isHighlighted = true;
    };

    const renderStatus = (statusCode: any, isAllApproved: boolean) => {
        return <OrderStatusCell statusCode={statusCode} isAllApproved={isAllApproved} />
    }

    const navigate = useNavigate();
    const goToBack = () => {
        navigate(`/syncflow/order-list`)
    }
    const order_supplier_status_cell_render = (data: any) => (t(data.orderLineReasonCode != null ? ('syncflow:lb_order_line_reason_status_' + data.orderLineReasonCode) : ""));
    return (
        <>
            <div className='row mb-4 justify-content-end'>
                <div className='col-auto'>
                    <Button
                        text={t("syncflow:btn_back")}
                        type="default"
                        icon="back"
                        stylingMode="contained"
                        onClick={goToBack}
                    />
                </div>
            </div>

            <div className="card-body py-3">
                <div className="table-responsive">
                    <table className="table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4">
                        <thead>
                            <tr className="fw-bold text-muted">
                                <th className="w-25px">
                                    <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                                </th>
                                <th className="min-w-150px">{t('syncflow:lb_type')}</th>
                                <th className="min-w-150px">{t('syncflow:lb_source_name')}</th>
                                <th className="min-w-140px">{t('syncflow:lb_vendor')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_order_number')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_order_date')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_delivery_date')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_cutoff')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_product_count')} </th>
                                <th className="min-w-120px">{t('syncflow:lb_order_quantity')} / {t('syncflow:lb_supplier_approved_quantity')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_order_amount')} / {t('syncflow:lb_supplier_approved_amount')}</th>
                                <th className="min-w-120px">{t('syncflow:lb_order_supplier_status')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="form-check form-check-sm form-check-custom form-check-solid"></div>
                                </td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{t('syncflow:lb_order_type_' + (account?.orderTypeCode))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(account?.sourceName)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(account?.targetName)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(account?.orderCode)}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(moment(account?.orderDate).format("DD/MM/YYYY"))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(moment(account?.deliveryDate).format("DD/MM/YYYY"))}</span></td>
                                <td><span className="text-gray-900 fw-bold text-hover-primary d-block fs-6">{(moment(account?.cutoff, 'hh:mm A').format('hh:mm A'))}</span></td>
                                <td><OrderStatusCell statusCode={account?.supplierStatusCode} isAllApproved={account?.orderQty == account?.venderApprovedQty} label={(account?.productCount + " / " + account?.vendorProductCount)} /></td>
                                <td><OrderStatusCell statusCode={account?.supplierStatusCode} isAllApproved={account?.orderQty == account?.venderApprovedQty} label={(account?.orderQty + " / " + account?.venderApprovedQty)} /></td>
                                <td><OrderStatusCell statusCode={account?.supplierStatusCode} isAllApproved={account?.orderQty == account?.venderApprovedQty} label={("$ " + account?.orderAmount + " / " + "$ " + account?.vendorAmount)} /></td>
                                <td><OrderStatusCell statusCode={account?.supplierStatusCode} isAllApproved={account?.orderQty == account?.venderApprovedQty} label={t('syncflow:lb_order_supplier_status_' + account?.supplierStatusCode)} /></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <React.Fragment>
                <DataGridWrapper
                    props={{ ref: dataGridRef }}
                    datasource={store}
                    remoteOperations={false}
                    columnChooser={true}
                    showColumnLines={true}
                    pagerVisible={true}
                    filterVisible={true}
                    headerFilterVisible={true}
                    keyboardNavigation={true}
                    onFocusedCellChanging={onFocusedCellChanging}
                    editingConfig={{
                        mode: "batch",
                        useIcons: true,
                        allowAdding: false,
                        allowDeleting: false,
                        allowUpdating: false,
                        updateMessageText: RemoveMessage('Resource'),
                    }}


                    columns={[
                        {
                            dataField: 'productCode',
                            caption: t('syncflow:lb_product_code'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'productName',
                            caption: t('syncflow:lb_product_name'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'unitCode',
                            caption: t('syncflow:lb_measurement_unit_code'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'orderQty',
                            caption: t('syncflow:lb_order_quantity'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'vendorApprovedQty',
                            caption: t('syncflow:lb_supplier_approved_quantity'),
                            allowFiltering: true,
                            allowEditing: false,
                        },
                        {
                            dataField: 'orderLineReasonCode',
                            caption: t('syncflow:lb_order_line_reason_name'),
                            allowFiltering: true,
                            allowEditing: false,
                            calculateCellValue: order_supplier_status_cell_render,
                        },
                        {
                            dataField: 'price',
                            caption: t('syncflow:lb_product_price'),
                            allowFiltering: true,
                            allowEditing: false,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                        {
                            dataField: 'amount',
                            caption: t('syncflow:lb_order_amount'),
                            allowFiltering: true,
                            allowEditing: false,
                            //calculateCellValue: amount_cell_calculation,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },
                        {
                            dataField: 'vendorApprovedAmount',
                            caption: t('syncflow:lb_supplier_approved_amount'),
                            allowFiltering: true,
                            allowEditing: false,
                            //calculateCellValue: amount_cell_calculation,
                            format: { style: "currency", currency: "USD", useGrouping: true }
                        },

                    ]}
                />
            </React.Fragment>

        </>


    )
}
export default OrderDetail